<!--
绑定手机号
-->
<template>
  <div class="bind-phone-box">
    <div class="title">绑定手机号</div>
    <div class="form-content">
      <van-field
        v-model="phone"
        label="手机号"
        size="large"
        placeholder="请输入手机号"
        :error-message="errorMsg"
      />
      <van-field
        v-model="phoneCode"
        center
        size="large"
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode">
          <span v-show="!display.showWait">发送验证码</span>
          <span v-show="display.showWait">{{waitSecond}}s</span>
        </van-button>
      </van-field>
      <van-button
        type="default"
        :block="true"
        class="bind-btn"
        color="#45C5DA"
        @click="bindPhone"
      >绑定</van-button>
    </div>
    <geetest
      ref="geetest"
      :phone="phone"
      :page-code="pageCode"
      :val-code="pageCode"
      @send-code-success="handlerSendCodeSuccess"
      @send-code-error="handlerSendCodefailed"
    ></geetest>
  </div>
</template>

<script>
  import api from 'api/user';
  import { mapState, mapActions } from 'vuex';
  import geetest from "components/geetest/geetest.vue";
  import { Toast } from 'vant';
  export default {
    components: { geetest },
    data(){
      return {
        display: {
          showWait: false
        },
        phone:'',
        phoneCode: '',
        errorMsg:'',
        pageCode: '',
        waitSecond: 60
      }
    },
    created() {
    },
    methods:{
      bindPhone(){
        if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
          this.errorMsg = '手机号格式错误';
          return
        }else{
          this.errorMsg = '';
        }
        if(!this.phoneCode) {
          Toast('请输入验证码')
          return
        }
        api.bindPhone({
          mobilePhone: this.phone,
          smsCode: this.phoneCode
        })
          .then(res => {
            this.$toast({
              type: 'success',
              message: '绑定成功'
            });
            //设置已注册手机号
            localStorage.setItem('ifBindPhone', 1)
            this.getuserInfo();
            this.$router.push({
              name: 'home'
            })
          })
          .catch(err => {
            Toast(err)
          })
        
      },
      //发送验证码
      sendCode() {
        if (this.display.showWait) return
        if ( this.phone === '' ) {
          Toast('请输入手机号');
          return
        }
        if (this.phone && (/^1[3456789]\d{9}$/.test(this.phone))){
          this.errorMsg = '';
          this.$refs.geetest.verify();
        }else{
          this.errorMsg = '手机号格式错误';
        }
      },
      // 发送验证码成功
      handlerSendCodeSuccess(res) {
        this.display.showWait = true;
        this.secondWait()
      },
      // 发送错误
      handlerSendCodefailed(err) {
        console.log(err);
      },
      secondWait: function() {
        let _this = this;
        _this.setInercalID = setTimeout(function() {
          if (_this.waitSecond > 0) {
            _this.waitSecond = _this.waitSecond - 1;
            _this.secondWait();
          } else {
            _this.display.showWait = false;
            clearTimeout(_this.setInercalID);
            _this.waitSecond = 60;
          }
        }, 1000);
      },
      ...mapActions(['getuserInfo'])
    }
  }
</script>

<style scoped lang="scss">
  .bind-phone-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100vh;
    background: url('../../assets/login/bg2.png') center/cover;
    .title{
      margin-top: 20px;
      font-size: 18px;
      color: #000;
    }
    .form-content{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 89vw;
      height: 45vh;
      min-height: 280px;
      margin-top: 7vh;
      padding-top: 20px;
      background: #ffffff;
      box-shadow: 0 0 8px 0 rgba(10, 138, 160, 0.1);
      border-radius: 8px;
      overflow: hidden;
      .bind-btn{
        position: absolute;
        bottom: 8vh;
        width: 80vw;
      }
    }
  }
</style>